import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// 👉 Configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDHJtMEYXn7yxffGJJWNgsea5X0W2wKUyk", //'TA_CLE_API_FIREBASE',
  authDomain: "bapp-qr.firebaseapp.com", //'TON_PROJECT.firebaseapp.com',
  projectId: "bapp-qr", //'TON_PROJECT_ID',
  appId: "1:858802238464:web:79b518047abe9b0d52d4e5", //'TON_APP_ID',
};

const firebaseApp = initializeApp(firebaseConfig);

// ✅ Autoriser debug token uniquement en dev
/*if (__DEV__) {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}*/

export const appCheck = initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaV3Provider("6LeEYT8rAAAAAPMBoH-nQkf7desJuKZ5xr2Q5Zir"), // ou custom provider si bare workflow
  //provider: new CustomProvider({ getToken: () => {/* no-op ou mock en dev */} }),
  isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(firebaseApp);
